/**
 * @description
 * Utility functions for authentication error handling.
 * Provides user-friendly error messages and titles.
 *
 * @author AI Developer <ai@byteable.ai>
 * @date October 7, 2025
 * @see admin/src/types/auth.ts
 */

/**
 * Get user-friendly error title based on error type
 */
export function getErrorTitle(errorType: string): string {
  switch (errorType) {
    case 'invalid_token':
    case 'expired_token':
      return 'Session Expired';
    case 'invalid_state':
      return 'Authentication Failed';
    case 'oauth_error':
      return 'Sign In Failed';
    case 'network_error':
      return 'Connection Error';
    case 'unauthorized':
      return 'Access Denied';
    default:
      return 'Something Went Wrong';
  }
}

/*
 * © 2025 Byte Inc. All rights reserved.
 * This code is the confidential and proprietary information of Byte Inc.
 * You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Byte Inc.
 */
